var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H6.465L8.16875 0.445C8.26003 0.30819 8.38364 0.196004 8.52864 0.118382C8.67363 0.0407602 8.83554 9.87561e-05 9 0H17C17.1645 9.87561e-05 17.3264 0.0407602 17.4714 0.118382C17.6164 0.196004 17.74 0.30819 17.8313 0.445L19.5363 3H23C23.7956 3 24.5587 3.31607 25.1213 3.87868C25.6839 4.44129 26 5.20435 26 6V20C26 20.7956 25.6839 21.5587 25.1213 22.1213C24.5587 22.6839 23.7956 23 23 23H3C2.20435 23 1.44129 22.6839 0.878679 22.1213C0.316071 21.5587 0 20.7956 0 20V6C0 5.20435 0.316071 4.44129 0.878679 3.87868C1.44129 3.31607 2.20435 3 3 3ZM8.5 12.5C8.5 13.39 8.76392 14.26 9.25839 15.0001C9.75285 15.7401 10.4557 16.3169 11.2779 16.6575C12.1002 16.9981 13.005 17.0872 13.8779 16.9135C14.7508 16.7399 15.5526 16.3113 16.182 15.682C16.8113 15.0526 17.2399 14.2508 17.4135 13.3779C17.5872 12.505 17.4981 11.6002 17.1575 10.7779C16.8169 9.95566 16.2401 9.25285 15.5001 8.75839C14.76 8.26392 13.89 8 13 8C11.8065 8 10.6619 8.47411 9.81802 9.31802C8.97411 10.1619 8.5 11.3065 8.5 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.06ab075d0f56209eaba8a1536ff5e52f.svg";
export { ForwardRef as ReactComponent };